// extracted by mini-css-extract-plugin
module.exports = {"notificationWrapper":"styles_notificationWrapper__Udbzu","alignCenter":"styles_alignCenter__Je_ZD","iconWrapper":"styles_iconWrapper__6fe2y","info":"styles_info__avHOB"};